import React, { useCallback } from 'react';
import * as slice from "../../store/speechConfig/speechConfigSlice";
import { useAppDispatch, useAppSelector } from "../../store/hook";
import { speechAction } from '../../store/speechConfig/speechConfigSlice';

export const useSpeechConfig = () => {
    const dispatch = useAppDispatch();
    return {
        loadSpeechConfig: useCallback((payload) => {
            dispatch(speechAction.loadSpeechConfig(payload));
        }, [dispatch]),
        save: useCallback((payload) => {
            dispatch(speechAction.saveCurrentSpeechConfig(payload));
        }, [dispatch]),

        speechConfigList: useAppSelector(slice.getSpeechConfig),
        loading: useAppSelector(slice.isLoading),
    }
}